<template>
  <div class="brand-sponsorships">
    <div class="banner">
      <v-img :src="`${currentDetails.bannerImage}`" alt="Banner" />
    </div>
    <div class="brand-ambassador-bg">
      <div class="carousel-wrapper">
        <button @click="scrollLeft" class="arrow left"><</button>
        <div class="sponsor-carousel" ref="sponsorCarousel">
          <div v-for="(sponsor, index) in sponsorshipsData" :key="index" class="card" @click="clickSponsor(index)" :class="{ active: index === currentIndex }">
            <img :src="sponsor.logo" alt="Team Logo" />
            <p class="sponsor-name">{{ sponsor.name }}</p>
            <p class="sponsor-year">{{ sponsor.year }}</p>
          </div>
        </div>
        <button @click="scrollRight" class="arrow right">></button>
      </div>
      <div class="desc">
        <p class="sponsor-title">{{ currentDetails.title }}</p>
        <p class="sponsor-name">{{ currentDetails.name }}</p>
        <p class="sponsor-league">{{ currentDetails.league }}</p>
        <p class="sponsor-content" v-html="currentDetails.content" />
      </div>
      <div class="iframe-ambassador" v-if="currentDetails.videoSource">
        <iframe
            :src="`${currentDetails.videoSource}`"
            width="100%"
            height="100%"
            style="border: none; overflow: hidden; border-radius: 10px; aspect-ratio: 16/9"
            allowfullscreen="false"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
      </div>
      <div class="gallery-wrapper">
        <button @click="scrollGalleryLeft" class="arrow left"><</button>
        <div class="gallery-carousel" ref="galleryCarousel">
          <div v-for="index in 6" :key="index" class="card">
            <img :src="`${currentDetails.gallery}_${index}.jpg`" />
          </div>
        </div>
        <button @click="scrollGalleryRight" class="arrow right">></button>
      </div>
    </div>
    <div class="bottom-banner">
      <v-img :src="`${currentDetails.bottomImage}`" alt="Bottom Banner" />
      <div class="bottom-line"></div>
    </div>
  </div>
</template>

<script>
import {locale, uiHelper} from "@/util";
import {SHARED} from "@/constants/constants";

  export default {
    name: 'sponsorships',
    data: () => ({
      currentIndex: 0,
      sponsorshipsData: [
        {
          name: 'Vegas Vikings',
          logo: SHARED.MEDIA_SERVER_URL + '/sponsorships/logo/vegas_vikings.png',
          year: '2025/2026',
          bannerImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/banner/vegas_vikings.jpg',
          title: locale.getMessage('footer.officialSponsorsOf'),
          league: 'Max60 Caribbean League 2025',
          content: locale.getMessage('sponsor.vegasVikings'),
          gallery: SHARED.MEDIA_SERVER_URL + '/sponsorships/gallery/vegas_vikings',
          bottomImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/bottom-banner/vegas_vikings.jpg',
          videoSource: 'https://www.youtube.com/embed/tJFXGy9mUEs'
        },
        {
          name: 'Sudurpaschim Royals',
          logo: SHARED.MEDIA_SERVER_URL + '/sponsorships/logo/sudurpaschim_royals.png',
          year: '2024/2025',
          bannerImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/banner/sudurpaschim_royals.jpg',
          title: locale.getMessage('footer.officialSponsorsOf'),
          league: 'Nepal Premier League 2024',
          content: locale.getMessage('sponsor.sudurpaschimRoyals'),
          gallery: SHARED.MEDIA_SERVER_URL + '/sponsorships/gallery/sudurpaschim_royals',
          bottomImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/bottom-banner/sudurpaschim_royals.jpg',
          videoSource: ''
        },
        {
          name: 'Telugu Warriors',
          logo: SHARED.MEDIA_SERVER_URL + '/sponsorships/logo/telugu_warriors.png',
          year: '2024/2025',
          bannerImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/banner/telugu_warriors.jpg',
          title: locale.getMessage('footer.officialSponsorsOf'),
          league: 'Celebrity Cricket League 2024',
          content: locale.getMessage('sponsor.teluguWarriors'),
          gallery: SHARED.MEDIA_SERVER_URL + '/sponsorships/gallery/telugu_warriors',
          bottomImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/bottom-banner/telugu_warriors.jpg',
          videoSource: ''
        },
        {
          name: 'Colombo Strikers',
          logo: SHARED.MEDIA_SERVER_URL + '/sponsorships/logo/colombo_strikers.png',
          year: '2024/2025',
          bannerImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/banner/colombo_strikers.jpg',
          title: locale.getMessage('footer.officialSponsorsOf'),
          league: 'Lanka Premier League 2024',
          content: locale.getMessage('sponsor.colomboStrikers'),
          gallery: SHARED.MEDIA_SERVER_URL + '/sponsorships/gallery/colombo_strikers',
          bottomImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/bottom-banner/colombo_strikers.jpg',
          videoSource: 'https://www.youtube.com/embed/_kUu6LRg32U'
        },
        // {
        //   name: 'Lumbini Lions',
        //   logo: SHARED.MEDIA_SERVER_URL + '/sponsorships/logo/lumbini_lions.png',
        //   year: '2024/2025',
        //   bannerImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/banner/lumbini_lions.jpg',
        //   title: locale.getMessage('footer.officialSponsorsOf'),
        //   league: 'Nepal Premier League 2024',
        //   content: locale.getMessage('sponsor.lumbiniLions'),
        //   gallery: SHARED.MEDIA_SERVER_URL + '/sponsorships/gallery/lumbini_lions',
        //   bottomImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/bottom-banner/lumbini_lions.jpg'
        // },
        {
          name: 'Grand Cayman Jaguars',
          logo: SHARED.MEDIA_SERVER_URL + '/sponsorships/logo/grand_cayman_jaguars.png',
          year: '2024/2025',
          bannerImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/banner/grand_cayman_jaguars.jpg',
          title: locale.getMessage('footer.officialSponsorsOf'),
          league: 'Max60 Caribbean League 2024',
          content: locale.getMessage('sponsor.grandCaymanJaguars'),
          gallery: SHARED.MEDIA_SERVER_URL + '/sponsorships/gallery/grand_cayman_jaguars',
          bottomImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/bottom-banner/grand_cayman_jaguars.jpg',
          videoSource: 'https://www.youtube.com/embed/2ZiHiQhxLec'
        },
        {
          name: 'Montreal Tigers',
          logo: SHARED.MEDIA_SERVER_URL + '/sponsorships/logo/montreal_tigers.png',
          year: '2023/2024',
          bannerImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/banner/montreal_tigers.jpg',
          title: locale.getMessage('footer.officialSponsorsOf'),
          league: 'Global T20 Canada 2023',
          content: locale.getMessage('sponsor.montrealTigers'),
          gallery: SHARED.MEDIA_SERVER_URL + '/sponsorships/gallery/montreal_tigers',
          bottomImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/bottom-banner/montreal_tigers.jpg',
          videoSource: 'https://geo.dailymotion.com/player.html?video=k654dAfcJ7idWcF02a4'
        },
        {
          name: 'Dambulla Aura',
          logo: SHARED.MEDIA_SERVER_URL + '/sponsorships/logo/dambulla_aurea.png',
          year: '2023/2024',
          bannerImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/banner/dambulla_aurea.jpg',
          title: locale.getMessage('footer.officialSponsorsOf'),
          league: 'Lanka Premier League 2023',
          content: locale.getMessage('sponsor.dambullaAura'),
          gallery: SHARED.MEDIA_SERVER_URL + '/sponsorships/gallery/dambulla_aurea',
          bottomImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/bottom-banner/dambulla_aurea.jpg',
          videoSource: 'https://www.youtube.com/embed/ku1qGVJtPy4'
        },
        {
          name: 'Northern Warriors',
          logo: SHARED.MEDIA_SERVER_URL + '/sponsorships/logo/northern_warriors.png',
          year: '2023/2024',
          bannerImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/banner/northern_warriors.jpg',
          title: locale.getMessage('footer.officialSponsorsOf'),
          league: 'Abu Dhabi T10 2023',
          content: locale.getMessage('sponsor.northernWarriors'),
          gallery: SHARED.MEDIA_SERVER_URL + '/sponsorships/gallery/northern_warriors',
          bottomImage: SHARED.MEDIA_SERVER_URL + '/sponsorships/bottom-banner/northern_warriors.jpg',
          videoSource: 'https://www.youtube.com/embed/lUoDJ-Rt_5M'
        },
      ]
    }),
    created() {
      this.metaTag();
      this.currentDetails()
    },
    computed: {
      currentDetails() {
        return this.sponsorshipsData[this.currentIndex]
      },
    },
    methods: {
      metaTag() {
        const currentUrl = window.location.href
        const domainWithProtocol = currentUrl.split('/')[2]
        const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
        const path = window.location.pathname
        const cleanPath = path.replace(/\/(en-BD|bn-BD)/i, '')
        const Links = `https://${domain}${cleanPath}`
        const Linksen = `https://${domain}/en-BD${cleanPath}`
        const Linksbn = `https://${domain}/bn-BD${cleanPath}`
        uiHelper.setHreflangLinks(Links)
        uiHelper.setHreflangLinksen(Linksen)
        uiHelper.setHreflangLinksbd(Linksbn)
      },
      clickSponsor(index) {
        this.currentIndex = index;
      },
      scrollLeft() {
        if(this.currentIndex > 0) {
          this.currentIndex --;
        }
        this.$refs.sponsorCarousel.scrollTo({ left: 148 * this.currentIndex, behavior: 'smooth' })
      },
      scrollRight() {
        if(this.currentIndex < this.sponsorshipsData.length -1) {
          this.currentIndex ++;
        }
        this.$refs.sponsorCarousel.scrollTo({ left: 148 * this.currentIndex , behavior: 'smooth' })
      },
      scrollGalleryLeft() {
        this.$refs.galleryCarousel.scrollBy({ left: -260, behavior: 'smooth' })
      },
      scrollGalleryRight() {
        this.$refs.galleryCarousel.scrollBy({ left: 260, behavior: 'smooth' })
      }
    }
  }
</script>

<style lang="scss">
  .brand-sponsorships {
    width: 100%;
    max-width: 1280px;
    background: #fff;
    justify-self: center;

    .banner {
      text-align: center;

      img {
        width: 100%;
        height: auto;
      }
    }

    .brand-ambassador-bg {
      background-color: #333333;
      padding: 20px 24px;

      @media (max-width: 599px) {
        padding: 12px;
      }

      .carousel-wrapper {
        display: flex;
        align-items: center;
        overflow: hidden;

        .sponsor-carousel {
          display: flex;
          width: 100%;
          overflow-x: auto;
          overflow-y: hidden;
          scroll-behavior: smooth;
          gap: 16px;
          margin: 0 16px;

          @media (max-width: 599px) {
            gap: 10px;
            margin: 0 8px;
          }
        }

        .card {
          min-width: 180px;
          height: 120px;
          padding: 10px;
          text-align: center;
          color: white;
          background-color: #474747;
          cursor: pointer;

          @media (max-width: 599px) {
            min-width: 148px;
            height: 100px;
          }

          img {
            width: 52px;
            height: 52px;

            @media (max-width: 599px) {
              width: 40px;
              height: 40px;
              margin-bottom: -2px;
            }
          }

          .sponsor-name {
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 0;

            @media (max-width: 599px) {
              font-size: 12px;
            }
          }

          .sponsor-year {
            font-size: 12px;

            @media (max-width: 599px) {
              font-size: 10px;
            }
          }
        }

        .card.active {
          color: #FFCE01;
          background-color: #1c1c1c;
        }

        .arrow {
          display: flex;
          font-size: 20px;
          width: 30px;
          height: 30px;
          border-radius: 16px;
          cursor: pointer;
          align-items: center;
          justify-content: center;
          color: white;
          background-color: #0080F6;

          @media (max-width: 599px) {
            font-size: 16px;
            width: 24px;
            height: 24px;
          }
        }
      }

      .desc {
        text-align: center;
        color: white;
        padding-top: 20px;

        .sponsor-title {
          font-size: 24px;
          font-weight: bolder;
          font-style: italic;
          color: #FFCE01;
          text-transform: uppercase;
          margin-bottom: -12px;

          @media (max-width: 599px) {
            font-size: 14px;
            margin-bottom: -2px;
          }
        }

        .sponsor-name {
          font-size: 36px;
          font-weight: bolder;
          font-style: italic;
          text-transform: uppercase;
          margin-bottom: -14px;

          @media (max-width: 599px) {
            font-size: 16px;
            margin-bottom: -4px;
          }
        }

        .sponsor-league {
          font-size: 24px;
          font-weight: bold;
          font-style: italic;
          text-transform: uppercase;

          @media (max-width: 599px) {
            font-size: 12px;
          }
        }

        .sponsor-content {
          font-size: 16px;

          @media (max-width: 599px) {
            font-size: 12px;
          }
        }
      }

      .gallery-wrapper {
        display: flex;
        align-items: center;
        overflow: hidden;
        padding: 10px;

        .gallery-carousel {
          display: flex;
          width: 100%;
          overflow-x: auto;
          scroll-behavior: smooth;
          gap: 16px;
          margin: 0 16px;

          @media (max-width: 599px) {
            gap: 10px;
            margin: 0 8px;
          }
        }

        .card {
          min-width: 220px;

          @media (max-width: 599px) {
            min-width: 100px;
          }
        }

        .card img {
          width: 100%;
          height: auto;
        }

        .arrow {
          display: flex;
          font-size: 20px;
          width: 30px;
          height: 30px;
          border-radius: 16px;
          cursor: pointer;
          align-items: center;
          justify-content: center;
          color: white;
          background-color: #0080F6;

          @media (max-width: 599px) {
            font-size: 16px;
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    .bottom-banner {
      text-align: center;

      img {
        width: 100%;
        height: auto;
      }

      .bottom-line {
        display: flex;
        width: 100%;
        height: 32px;
        background-color: #FFCE01;

        @media (max-width: 599px) {
          height: 12px;
        }
      }
    }
  }
</style>